import React, { useState, useEffect } from "react";
import styles from "../../../styles/components/artistProfile.module.css";
import {
  Badge,
  Box,
  Stack,
  Image,
  Avatar,
  Button,
  Center,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  Spacer,
} from "@chakra-ui/react";
import useIpAddress from "../../../hooks/useIpAddress";

import Link from "next/link";
import { getUrl } from "../../../hairstylistsData";
import ServiceImagePane from "../../../components/artistProfile/ServiceImagePane";
import ImagesSlider from "../../../components/artistProfile/ImageSlider";
import ProfileLayout from "../../../components/templates/ProfileLayout";
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  TriangleDownIcon,
  TriangleUpIcon,
} from "@chakra-ui/icons";
import { useRouter } from "next/router";
import { Mongo } from "../../../util/MongoScript";
import { NextSeo } from "next-seo";
import UiButton from "../../../components/atoms/UiButton";
import { useSession } from "next-auth/client";
export default function artistDetail({ data }) {
  //new structure
  const artistData = JSON.parse(data?.artistList);
  const serviceTypesList = JSON.parse(data?.serviceTypesList);
  const [showMore, setshowMore] = useState(false);
  const [isOpenHours, setisOpenHours] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const router = useRouter();
  const [session, loadingSession] = useSession();
  const [isCurrentUserExist, setisCurrentUserExist] = useState(false);
  const [loader, setloader] = useState(false);
  const ipAddress = useIpAddress();
  const [isClaimBtnShow, setisClaimBtnShow] = useState(false);
  const requestFunction = async (email) => {
    var idRes = await fetch(`/api/newStructure/artist?email=${email}`, {
      method: "GET",
    });
    const dataRes = await idRes?.json();

    const isClaimBtnShow =
      dataRes?.response && dataRes?.response?.artist?.isclaimed === false;
    setisClaimBtnShow(isClaimBtnShow);
    setloader(false);
  };
  useEffect(() => {
    if (session?.user?.email) {
      setloader(true);
      requestFunction(session?.user?.email);
    } else {
      setisClaimBtnShow(true);
    }
  }, [artistData?.email, session?.user?.email]);
  useEffect(() => {
    saveVisitor();
  }, []);

  const saveVisitor = async () => {
    const response = await fetch("https://api.ipify.org?format=json");
    const { ip } = await response.json();
    await fetch("/api/newStructure/artistLogs", {
      method: "POST",
      body: JSON.stringify({
        artistId: artistData?._id,
        sourceurl: document.referrer,
        ip: ip,
      }),
    });
  };
  // Services List
  const filteredServiceTypes = [];
  serviceTypesList?.map((item) => {
    var isAppend = false;
    artistData?.servicesList?.map((ser) => {
      if (ser?.serviceTypeId === item?._id) {
        isAppend = true;
      }
    });
    if (isAppend) {
      filteredServiceTypes?.push(item);
    }
  });

  const sortedServiceTypesArray = filteredServiceTypes?.sort((a, b) =>
    a?.name?.localeCompare(b?.name)
  );
  const [selectedServiceList, setselectedServiceList] = useState(
    artistData?.servicesList.filter(
      (i) => i.serviceTypeId === sortedServiceTypesArray[0]?._id
    )
  );
  const [selectedSerId, setSelectedSerId] = useState(
    sortedServiceTypesArray?.[0]?._id
  );
  const onServiceTypeClick = async (id) => {
    setSelectedSerId(id);
    const list = await artistData?.servicesList.filter(
      (i) => i.serviceTypeId === id
    );
    setselectedServiceList(list);
  };
  // Filtered Service Types Array which are located inside Artists Data Object
  const serviceTypeArray = artistData?.servicesList?.filter((item) => {
    if (selectedSerId == item.serviceTypeId) {
      return item;
    }
  });
  const imageArray = [];
  serviceTypeArray?.forEach((item) => {
    item?.images?.cover?.forEach((cover) => {
      if (!imageArray.includes(cover)) {
        imageArray.push(cover);
      }
    });
    item?.images?.lookbook?.forEach((item) => {
      item?.assets?.forEach((ele) => {
        if (!imageArray.includes(ele)) {
          imageArray.push(ele);
        }
      });
    });
  });
  const serviceTypeObj = serviceTypeArray?.[0];
  const artistStreet =
    artistData?.address?.street !== undefined
      ? artistData?.address?.street + ","
      : "";
  const artistAdderesss =
    artistStreet +
    " " +
    (artistData?.address?.city + ", " + artistData?.address?.zip || "Montreal");
  const selectedSer = sortedServiceTypesArray?.find(
    (item) => item?._id === selectedSerId
  );
  const refactorbusinessName = artistData?.businessName.split(" ").join("-");
  const title = `${refactorbusinessName} | ${artistData?.address?.city}, QC Canada | CoverClap`;
  const artistSubService = [];
  artistData?.servicesList.forEach((element) => {
    if (element?.subServiceId) {
      artistSubService.push(element?.subServiceId);
    }
  });
  if (artistSubService?.length === 0) {
    artistData?.servicesList.forEach((element) => {
      artistSubService.push(element);
    });
  }
  const currentDay = new Date().getDay() - 1;

  const isProfileclamed = artistData?.isclaimed ? true : false;
  const hourList =
    artistData?.hours && artistData?.hours.length > 0
      ? artistData?.hours
      : false;

  const isClaimClickAble =
    session && session?.user?.email === artistData?.email;
  return (
    <ProfileLayout showModal={showModal} setShowModal={setShowModal}>
      {loader || loadingSession ? (
        <h1>Loading...</h1>
      ) : (
        <>
          <NextSeo
            noindex={true}
            title={title || "CoverClap: Artist name and city"}
            description={
              artistData?.businessName +
              " provides " +
              selectedSer?.name?.toLowerCase() +
              ", " +
              artistData?.servicesList[0]?.name +
              ", " +
              (artistData?.servicesList[1]?.name == undefined
                ? ""
                : artistData?.servicesList[1]?.name) +
              ", " +
              (artistData?.servicesList[2]?.name == undefined
                ? ""
                : artistData?.servicesList[2]?.name) +
              " professional services in Montreal. Visit the profile and book today."
            }
            openGraph={{
              url:
                "https://coverclap.com/a/" +
                refactorbusinessName?.toLowerCase(),
              type: "website",
              siteName: "CoverClap",
              images: [
                {
                  url:
                    artistData?.avatar?.slice(0, 4) === "http"
                      ? artistData?.avatar
                      : getUrl(artistData?._id, artistData?.avatar),
                  width: 800,
                  height: 806,
                },
              ],
            }}
          />
          <Box className={styles.main}>
            <div
              onClick={() => {
                if (
                  window.history.length === 1 ||
                  window.history.length === 2
                ) {
                  router.push("/");
                } else {
                  window.history.back();
                }
              }}
            >
              <Box className={styles.webBackBtn}>
                <ChevronLeftIcon boxSize={10} />
                <p>See artists</p>
              </Box>
            </div>
            <Box className={styles.upperRow}>
              <Box pr="50px" className={styles.rowLeft}>
                <Box className={styles.avatarBox}>
                  <Avatar
                    boxSize={"124px"}
                    src={
                      artistData?.avatar?.slice(0, 4) === "http"
                        ? artistData?.avatar
                        : getUrl(artistData?._id, artistData?.avatar)
                    }
                    name={artistData?.businessName}
                  />
                </Box>
                <Box style={{ width: "100%" }} className={styles.nameContainer}>
                  <Box className={styles.nameCont}>
                    <Box as="p">{artistData?.businessName || ""}</Box>

                    {artistData?.sponsoredArtist && (
                      <Box className={styles.sponsred}>
                        <img src="/new-ui/images/badge.svg" alt="Badge" />{" "}
                        Sponsored
                      </Box>
                    )}
                  </Box>
                  <Box className={styles.locCont}>
                    <Box mr="10px" as="p">
                      {artistAdderesss}
                    </Box>
                    <Image cursor={"pointer"} src="/images/externel-link.svg" />
                  </Box>

                  <Stack className={styles.badgesCont} direction="row">
                    {artistData?.ethnicArtistServices && (
                      <Badge className={styles.ethnicBadge}>
                        {artistData?.ethnicArtistServices?.name}
                      </Badge>
                    )}
                    {artistSubService?.slice(0, 2)?.map((item, index) => {
                      return (
                        <Badge className={styles.badge} key={index}>
                          {item?.name?.slice(0, 35)}
                        </Badge>
                      );
                    })}
                    {artistSubService?.length > 3 && (
                      <Box className={styles.plusNum} as="p">
                        +{artistSubService?.length - 2}
                      </Box>
                    )}
                  </Stack>
                  <Box ml="-20px" className={styles.centerParagrphforWeb}>
                    {showMore
                      ? artistData?.bio
                      : artistData?.bio?.slice(0, 500)}
                    {artistData?.bio?.length > 500 && (
                      <>
                        {showMore ? (
                          <span
                            className={styles?.showMore}
                            onClick={() => {
                              setshowMore(!showMore);
                            }}
                            style={{}}
                          >
                            Show less
                          </span>
                        ) : (
                          <>
                            ...
                            <span
                              className={styles?.showMore}
                              onClick={() => {
                                setshowMore(!showMore);
                              }}
                            >
                              Show more
                            </span>
                          </>
                        )}
                      </>
                    )}
                  </Box>
                  <Stack mt="40px" direction={"row"}>
                    {hourList ? (
                      <Box position={"relative"}>
                        <Box
                          cursor={"pointer"}
                          onClick={() => setisOpenHours(!isOpenHours)}
                          className={styles.hours}
                          style={{ display: "flex", alignItems: "center" }}
                          as="p"
                        >
                          <b>Hours:</b>
                          <Box color={"#67B7C2"} px="4px">
                            {" "}
                            Open
                          </Box>
                          . Closes 6 p.m.{" "}
                          {isOpenHours ? (
                            <TriangleUpIcon fontSize={"12px"} ml={"10px"} />
                          ) : (
                            <TriangleDownIcon fontSize={"12px"} ml={"10px"} />
                          )}
                        </Box>
                        {isOpenHours && (
                          <Box pt="15px" pl="55px">
                            {hourList?.map((item, index) => {
                              return (
                                <Flex
                                  w={"200px"}
                                  justifyContent={"space-between"}
                                >
                                  <Box
                                    as="p"
                                    fontWeight={index === currentDay && "bold"}
                                    className={styles.hours}
                                  >
                                    {item.day}
                                  </Box>
                                  <Box
                                    as="p"
                                    w="100px"
                                    whiteSpace={"nowrap"}
                                    fontWeight={index === currentDay && "bold"}
                                    className={styles.hours}
                                  >
                                    {" "}
                                    {item?.opens === "Closed"
                                      ? "Closed"
                                      : `${item.opens}–${item.closes}.`}
                                  </Box>
                                </Flex>
                              );
                            })}
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box position={"relative"}>
                        <Box
                          cursor={"pointer"}
                          onClick={() => setisOpenHours(!isOpenHours)}
                          className={styles.hours}
                          style={{ display: "flex", alignItems: "center" }}
                          as="p"
                        >
                          <b style={{ fontWeight: "500" }}>Hours: </b>
                          <Box px="4px"> Unknown</Box>
                        </Box>
                      </Box>
                    )}

                    <Spacer />
                    <Box>
                      <Box className={styles.locCont}>
                        <Box mr="10px" as="p">
                          <b style={{ fontWeight: "500" }}>Address: </b>
                          {artistData?.address?.street} <br />{" "}
                          {artistData?.address?.city +
                            ", " +
                            artistData?.address?.zip}{" "}
                        </Box>
                        <Spacer />
                        <Image
                          cursor={"pointer"}
                          src="/images/externel-link.svg"
                        />
                      </Box>
                      {artistData?.website && (
                        <Box
                          justifyContent={"space-between"}
                          mt="20px"
                          className={styles.locCont}
                        >
                          <Box display={"flex"} mr="10px" as="p">
                            <b style={{ fontWeight: "500" }}>Website: </b>
                            <Box pl="5px" cursor={"pointer"} color={"#67B7C2"}>
                              <a target={"_blank"} href={artistData?.website}>
                                {artistData?.website}
                              </a>
                            </Box>
                          </Box>
                          <Spacer />
                          <Image
                            cursor={"pointer"}
                            src="/images/externel-link.svg"
                          />
                        </Box>
                      )}
                    </Box>
                  </Stack>
                </Box>
              </Box>

              <Box className={styles.rowRight}>
                {isClaimBtnShow && (
                  <Box className={styles.claimProfile}>
                    <Box className={styles.claimProfileTitle} as={"p"}>
                      Claim this profile
                    </Box>
                    <Box className={styles.claimProfileDescription} as={"p"}>
                      Connect with thousands of beauty enthusiasts in MTL.{" "}
                      <br />
                      {isClaimClickAble ? (
                        <a
                          href="/welcome"
                          className={styles.claimProfileHighlight}
                        >
                          <b style={{ fontWeight: 400 }}>Claim your profile </b>
                        </a>
                      ) : (
                        <span
                          onClick={() => {
                            if (!session) {
                              setShowModal(true);
                            }
                          }}
                          className={styles.claimProfileHighlight}
                        >
                          <b style={{ fontWeight: 400 }}>Claim your profile </b>
                        </span>
                      )}
                      now and see your statistics and visitor interactions soar!
                    </Box>
                    <Button
                      mt="40px"
                      bg="#ACB0B3"
                      ml="65px"
                      mb="59px"
                      _hover={{
                        bg: "#ACB0B3",
                        color: "white",
                      }}
                      _active={{
                        bg: "#ACB0B3",
                        color: "white",
                        opacity: 0.8,
                      }}
                      className={styles.claimProfileDescription}
                      color="white"
                      rounded={"5px"}
                      height="54px"
                      width="172px"
                      onClick={() => {
                        artistData?.cta && router.push(artistData?.cta);
                      }}
                    >
                      Book a service
                    </Button>
                  </Box>
                )}

                <Box className={styles.socialIconsContainer}>
                  <p className={styles.socialHeading1}>Social</p>
                  <Box
                    className={
                      !artistData?.socialMedia?.Facebook && styles.disable
                    }
                  >
                    <Link href={artistData?.socialMedia?.Facebook || ""}>
                      <a target="_blank" rel="noopener noreferrer">
                        <Box className={styles.socialRow}>
                          <img
                            className={styles.socialIcon}
                            src="/images/fb-icon.png"
                            alt="Facebook Icon"
                          />
                          <p className={styles.socialText}>Facebook</p>
                        </Box>
                      </a>
                    </Link>
                  </Box>
                  <Box
                    className={
                      !artistData?.socialMedia?.Instagram && styles.disable
                    }
                  >
                    <Link href={artistData?.socialMedia?.Instagram || ""}>
                      <a target="_blank" rel="noopener noreferrer">
                        <Box className={styles.socialRow}>
                          <img
                            className={styles.socialIcon}
                            src="/images/insta-icon.png"
                            alt="Insta Icon"
                          />
                          <p className={styles.socialText}>Instagram</p>
                        </Box>
                      </a>
                    </Link>
                  </Box>
                  <Box
                    className={
                      !artistData?.socialMedia?.Twitter && styles.disable
                    }
                  >
                    <Link href={artistData?.socialMedia?.Twitter || ""}>
                      <a target="_blank" rel="noopener noreferrer">
                        <Box className={styles.socialRow}>
                          <img
                            className={styles.socialIcon}
                            src="/images/twitter-icon.png"
                            alt="Twitter Icon"
                          />
                          <p className={styles.socialText}>Twitter</p>
                        </Box>
                      </a>
                    </Link>
                  </Box>
                  <Box
                    className={
                      !artistData?.socialMedia?.Toktok && styles.disable
                    }
                  >
                    <Link href={artistData?.socialMedia?.Toktok || ""}>
                      <a target="_blank" rel="noopener noreferrer">
                        <Box className={styles.socialRow}>
                          <img
                            className={styles.socialIcon}
                            src="/images/tiktok-icon.png"
                            alt="Toktok Icon"
                          />
                          <p className={styles.socialText}>Tok Tok</p>
                        </Box>
                      </a>
                    </Link>
                  </Box>
                </Box>

                {artistData?.sponsoredArtist && (
                  <Box className={styles.websponseredContainer}>
                    <Box className={styles.websocialHeading}>Sponsored</Box>
                    <Box className={styles.websponseredParagraph}>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Ante ipsum ut dui feugiat id quam. Nulla tincidunt
                      adipiscing fringilla vehicula.
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
            <Box></Box>
          </Box>

          <Box className={styles.mblMain}>
            <div
              onClick={() => {
                if (
                  window.history.length === 1 ||
                  window.history.length === 2
                ) {
                  router.push("/");
                } else {
                  window.history.back();
                }
              }}
            >
              <Box className={styles.backMobileBtn}>
                <ChevronLeftIcon boxSize={10} />
                <p>See artists</p>
              </Box>
            </div>
            {artistData?.sponsoredArtist && (
              <Box className={styles.centersponsered}>
                <Box className={styles.mobilesponsred}>
                  <img
                    src="/new-ui/images/badge.svg"
                    alt="Badge"
                    className={styles.mobileSponseredImage}
                    width={"8px"}
                    height={"10px"}
                  />{" "}
                  Sponsored
                </Box>
              </Box>
            )}

            <Box className={styles.avtcntr}>
              <Box className={styles.avatarBox}>
                <Avatar
                  boxSize={"100px"}
                  src={
                    artistData?.avatar?.slice(0, 4) === "http"
                      ? artistData?.avatar
                      : getUrl(artistData?._id, artistData?.avatar)
                  }
                  name={artistData?.businessName}
                />
              </Box>
              <Box
                style={{
                  flex: 2,
                }}
              >
                <Box className={styles.nameCont}>
                  {/*<img src="/new-ui/images/profile.svg" alt="Profile" />*/}
                  <h1>
                    <Box as="p">{artistData?.businessName || ""}</Box>
                  </h1>
                  {artistData?.sponsoredArtist && (
                    <Box className={styles.sponsred}>
                      <img src="/new-ui/images/badge.svg" alt="Badge" />{" "}
                      Sponsored
                    </Box>
                  )}
                </Box>
                <Box className={styles.locCont}>
                  {/* <img src="/new-ui/images/location.svg" alt="Location" /> */}
                  <Box as="p">{artistAdderesss}</Box>
                  <Image cursor={"pointer"} src="/images/externel-link.svg" />
                </Box>
              </Box>
            </Box>

            <Stack className={styles.badgesCont} direction="row">
              {artistData?.ethnicArtistServices && (
                <Badge className={styles.ethnicBadge}>
                  {artistData?.ethnicArtistServices?.name}
                </Badge>
              )}
              {artistSubService?.slice(0, 2)?.map((item, index) => {
                return (
                  <Badge className={styles.badge} key={index}>
                    {item?.name?.slice(0, 35)}
                  </Badge>
                );
              })}
              {artistSubService?.length > 2 && (
                <Box
                  bgGradient="linear(to-l, rbga(1,1,1,0.2), rbga(1,1,1,1))"
                  className={styles.plusNum}
                  as="p"
                >
                  +{artistSubService?.length - 2}
                </Box>
              )}
            </Stack>
            {/* <Box className={styles.iconList}>
          {icons.map((icon, index) => {
            return (
              <Link key={index} href={icon.link}>
                <Box className={styles.link}>
                  <img src={icon.icon} alt={icon.name} loading="lazy" />
                </Box>
              </Link>
            );
          })}
        </Box> */}
          </Box>
          <Box pt="-10px" mb="32px" px="20px">
            {isClaimBtnShow && (
              <Box className={styles.profileDetailsMobile}>
                <Box
                  className={styles.claimProfileTitle}
                  style={{ fontSize: "16px" }}
                  as={"p"}
                >
                  Claim this profile
                </Box>
                <Box
                  style={{ fontSize: "14px" }}
                  className={styles.claimProfileDescription}
                  as={"p"}
                >
                  Connect with thousands of beauty enthusiasts in MTL. <br />
                  {isClaimClickAble ? (
                    <a href="/welcome" className={styles.claimProfileHighlight}>
                      <b style={{ fontWeight: 400 }}>Claim your profile </b>
                    </a>
                  ) : (
                    <span
                      onClick={() => {
                        if (!session) {
                          setShowModal(true);
                        }
                      }}
                      className={styles.claimProfileHighlight}
                    >
                      <b style={{ fontWeight: 400 }}>Claim your profile </b>
                    </span>
                  )}
                  now and see your statistics and visitor interactions soar!
                </Box>
              </Box>
            )}
          </Box>
          {artistData?.bio !== "" && (
            <>
              <Box className={styles.centerParagrph}>
                {showMore ? artistData?.bio : artistData?.bio?.slice(0, 225)}
                {artistData?.bio?.length > 225 && (
                  <>
                    {showMore ? (
                      <span
                        className={styles?.showMore}
                        onClick={() => {
                          setshowMore(!showMore);
                        }}
                        style={{
                          marginLeft: 10,
                        }}
                      >
                        Show less
                      </span>
                    ) : (
                      <>
                        ...
                        <span
                          className={styles?.showMore}
                          onClick={() => {
                            setshowMore(!showMore);
                          }}
                        >
                          Show more
                        </span>
                      </>
                    )}
                  </>
                )}
              </Box>
            </>
          )}

          <Box className={styles.mobileIcons}>
            {/* <Box className={styles.claimProfile}>
              <Center>
                <Button
                  ml="-30px"
                  bg="#ACB0B3"
                  mb="59px"
                  _hover={{
                    bg: "#ACB0B3",
                    color: "white",
                  }}
                  _active={{
                    bg: "#ACB0B3",
                    color: "white",
                    opacity: 0.8,
                  }}
                  className={styles.claimProfileDescription}
                  color="white"
                  rounded={"5px"}
                  height="54px"
                  width="172px"
                  onClick={() => {
                    artistData?.cta && router.push(artistData?.cta);
                  }}
                >
                  Book a service
                </Button>
              </Center>
            </Box> */}
            <Stack mt="-20px" mb="30px">
              {hourList ? (
                <Box position={"relative"}>
                  <Box
                    cursor={"pointer"}
                    onClick={() => setisOpenHours(!isOpenHours)}
                    className={styles.hours}
                    style={{ display: "flex", alignItems: "center" }}
                    fontSize="18px"
                    as="p"
                  >
                    <b style={{ fontSize: "20px" }}>Hours:</b>{" "}
                    <Box color={"#67B7C2"} fontSize="18px" px="4px">
                      {" "}
                      Open
                    </Box>
                    . Closes 6 p.m.{" "}
                    {isOpenHours ? (
                      <TriangleUpIcon fontSize={"12px"} ml={"10px"} />
                    ) : (
                      <TriangleDownIcon fontSize={"12px"} ml={"10px"} />
                    )}
                  </Box>
                  {isOpenHours && (
                    <Box pt="15px" pl="55px">
                      {hourList?.map((item, index) => {
                        return (
                          <Flex w={"220px"} justifyContent={"space-between"}>
                            <Box
                              as="p"
                              style={{ fontSize: "18px" }}
                              fontWeight={index === currentDay && "bold"}
                              className={styles.hours}
                            >
                              {item.day}
                            </Box>
                            <Box
                              as="p"
                              style={{ fontSize: "18px" }}
                              w="100px"
                              whiteSpace={"nowrap"}
                              fontWeight={index === currentDay && "bold"}
                              textAlign="right"
                              className={styles.hours}
                            >
                              {" "}
                              {item?.opens === "Closed"
                                ? "Closed"
                                : `${item.opens}–${item.closes}.`}
                            </Box>
                          </Flex>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              ) : (
                <Box position={"relative"}>
                  <Box
                    cursor={"pointer"}
                    onClick={() => setisOpenHours(!isOpenHours)}
                    className={styles.hours}
                    style={{ display: "flex", alignItems: "center" }}
                    as="p"
                  >
                    <b style={{ fontWeight: "500", fontSize: "20px" }}>
                      Hours:{" "}
                    </b>
                    <Box px="4px"> Unknown</Box>
                  </Box>
                </Box>
              )}

              <Box pt="20px">
                <Box pr="20px" className={styles.locCont}>
                  <Box mr="10px" style={{ fontSize: "18px" }} as="p">
                    <b style={{ fontSize: "20px", fontWeight: "500" }}>
                      Address:
                    </b>{" "}
                    {artistData?.address?.street} <br />{" "}
                    {artistData?.address?.city +
                      ", " +
                      artistData?.address?.zip}{" "}
                  </Box>
                  <Spacer />
                  <Image cursor={"pointer"} src="/images/externel-link.svg" />
                </Box>
                {artistData?.website && (
                  <Box
                    justifyContent={"space-between"}
                    mt="30px"
                    pr="20px"
                    className={styles.locCont}
                  >
                    <Box
                      display={"flex"}
                      style={{ fontSize: "18px" }}
                      mr="10px"
                      as="p"
                    >
                      <b style={{ fontSize: "20px", fontWeight: "500" }}>
                        Website:
                      </b>
                      <Box pl="6px" cursor={"pointer"} color={"#67B7C2"}>
                        <a target={"_blank"} href={artistData?.website}>
                          {" "}
                          {`${artistData?.website?.slice(0, 25)}`}
                        </a>
                      </Box>
                    </Box>
                    <Spacer />
                    <a target={"_blank"} href={artistData?.website}>
                      <Image
                        cursor={"pointer"}
                        src="/images/externel-link.svg"
                      />
                    </a>
                  </Box>
                )}
              </Box>
            </Stack>
            <Box className={styles.socialIconsContainer}>
              <p
                style={{ fontSize: "20px", fontWeight: "500" }}
                className={styles.socialHeading1}
              >
                Social
              </p>
              <Box
                className={!artistData?.socialMedia?.Facebook && styles.disable}
              >
                <Link href={artistData?.socialMedia?.Facebook || ""}>
                  <a target="_blank" rel="noopener noreferrer">
                    <Box className={styles.socialRow}>
                      <img
                        className={styles.socialIcon}
                        src="/images/fb-icon.png"
                        alt="Facebook Icon"
                      />
                      <p className={styles.socialText}>Facebook</p>
                    </Box>
                  </a>
                </Link>
              </Box>
              <Box
                className={
                  !artistData?.socialMedia?.Instagram && styles.disable
                }
              >
                <Link href={artistData?.socialMedia?.Instagram || ""}>
                  <a target="_blank" rel="noopener noreferrer">
                    <Box className={styles.socialRow}>
                      <img
                        className={styles.socialIcon}
                        src="/images/insta-icon.png"
                        alt="Insta Icon"
                      />
                      <p className={styles.socialText}>Instagram</p>
                    </Box>
                  </a>
                </Link>
              </Box>
              <Box
                className={!artistData?.socialMedia?.Twitter && styles.disable}
              >
                <Link href={artistData?.socialMedia?.Twitter || ""}>
                  <a target="_blank" rel="noopener noreferrer">
                    <Box className={styles.socialRow}>
                      <img
                        className={styles.socialIcon}
                        src="/images/twitter-icon.png"
                        alt="Twitter Icon"
                      />
                      <p className={styles.socialText}>Twitter</p>
                    </Box>
                  </a>
                </Link>
              </Box>
              <Box
                className={!artistData?.socialMedia?.Toktok && styles.disable}
              >
                <Link href={artistData?.socialMedia?.Toktok || ""}>
                  <a target="_blank" rel="noopener noreferrer">
                    <Box className={styles.socialRow}>
                      <img
                        className={styles.socialIcon}
                        src="/images/tiktok-icon.png"
                        alt="Toktok Icon"
                      />
                      <p className={styles.socialText}>Tok Tok</p>
                    </Box>
                  </a>
                </Link>
              </Box>
            </Box>
          </Box>
          {artistData?.sponsoredArtist && (
            <Box className={styles.socialContainer}>
              <Box className={styles.socialHeading}>Sponsored</Box>
              <Box className={styles.sponseredParagraph}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ante
                ipsum ut dui feugiat id quam. Nulla tincidunt adipiscing
                fringilla vehicula.
              </Box>
            </Box>
          )}

          {/* <Box className={styles.smallScreeBookServiceBtn}>
        <UiButton hFull bgColor={"#000000"} label={"Book a Service"} />
      </Box> */}
          <ServiceImagePane
            onClick={onServiceTypeClick}
            servicesArray={sortedServiceTypesArray}
          />
          {imageArray.length > 0 && isProfileclamed && (
            <Box className={styles.tabPaneContainer}>
              <ImagesSlider obj={artistData} imageArray={imageArray} />
            </Box>
          )}

          <Box className={styles.bottomCardWrapper}>
            {selectedServiceList?.map((item, index) => {
              const getServiceDetail = serviceTypesList?.find(
                (i) => i._id === item.serviceTypeId
              );
              return (
                <Box className={styles.bottomCardImageContainer} key={index}>
                  {index % 2 === 0 ? (
                    <img
                      className={styles.blog__top__bottomBgSM}
                      src="/new-ui/images/blog-sm-top-left-bg.png"
                    />
                  ) : (
                    <img
                      className={styles.blog__top__rightBgSM}
                      src="/new-ui/images/blog-sm-top-right-bg.png"
                    />
                  )}

                  <Box className={styles.bottomCard}>
                    <Box className={styles.bottomCardTitle}>
                      <h2>{item?.name}</h2>
                    </Box>
                    <Box className={styles.rightLeft}>
                      <Box className={styles.price}>
                        <Box as="p">
                          $
                          {parseInt(
                            item?.price?.price?.toString()?.split("$")?.join("")
                          )}
                        </Box>
                        <Box className={styles.min}>
                          {item?.price?.priceType === "from" && "Min Price"}
                        </Box>
                      </Box>
                      <Box className={styles.eye}>
                        <img src="/new-ui/images/clock.svg" alt="Location" />
                        <Box as="p">
                          Service duration: {parseInt(item.price?.duration)} min
                        </Box>
                      </Box>
                    </Box>
                    <Box as="p" className={styles.serviceParagraph}>
                      {item?.subServiceId?.description ||
                        getServiceDetail?.description}
                    </Box>
                    {/* <Box className={styles.BottomCardrightBtn}>
                      <UiButton
                        hFull
                        bgColor={"#000000"}
                        label={"Book a Service"}
                        onClick={() => {
                          artistData?.cta && router.push(artistData?.cta);
                        }}
                      />
                    </Box> */}
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box className={styles.bottomMargin}></Box>
        </>
      )}
    </ProfileLayout>
  );
}

export async function getStaticProps({ params }) {
  const refactorbusinessName = params.artist_id;
  let [artistList, serviceTypesList] = await Promise.all([
    Mongo.findOneWithPopulate("Artist", { userName: refactorbusinessName }, [
      {
        path: "ethnicArtistServices",
        model: "EthnicArtists",
      },
      {
        path: "servicesList",
        model: "ArtistServices",
        match: {
          name: {
            $gte: " ",
          },
        },
        populate: [
          {
            path: "subServiceId",
            model: "SubServices",
          },
          {
            path: "images",
            model: "Artistimages",
          },
        ],
      },
    ]),
    Mongo.findAll("ServiceTypes"),
  ]);
  const data = {
    // new structure
    artistList: JSON.stringify(artistList),
    serviceTypesList: JSON.stringify(serviceTypesList),
  };
  return {
    props: {
      data,
    },
    revalidate: 1,
  };
}
export async function getStaticPaths() {
  let artists = await Mongo.findAll("Artist", {
    onBoarded: true,
    isActivated: true,
  });
  artists = JSON.parse(JSON.stringify(artists));

  const paths = [];
  for (let artist of artists) {
    const artistCity = artist?.address?.city || "Montreal";
    paths.push({
      params: {
        artist_id: artist?.userName,
        city: artistCity?.toLowerCase(),
      },
    });
  }
  return {
    paths: paths,
    fallback: false, // can also be true or 'blocking'
  };
}
